import { Outlet } from "react-router-dom";
import "./project-general-view.scss";

export const ProjectDocstoreView = () => {
  return (
    <div className="docstore-general-view-container">
      <Outlet />
    </div>
  );
};
